'use client'
import PageGutter from '@/src/components/common/PageGutter'
import styles from './LargeHeroBannerBlock.module.scss'
import DirectusImage from '@/src/components/common/DirectusImage'
import { Block_Large_Hero_Banner } from '@/src/generated/graphql'
import CTAButton from '@/src/components/common/CTAButton'
import { classNames } from '@/src/helpers/component'
import { useState } from 'react'

const TextCard = ({ _idx, ...data }: Block_Large_Hero_Banner & { _idx: number }) => {
  const [flipped, setFlipped] = useState(false)

  /*@ts-expect-error always present*/
  const moreText = data[`card${_idx}_more_text`]

  return (
    <div
      className={classNames(
        styles.textCard,
        flipped ? styles.flipped : '',
        moreText ? styles.hasMore : '',
      )}
      onClick={() => {
        if (moreText) setFlipped(!flipped)
      }}>
      <div className={styles.flipInner}>
        <div className={styles.flipFront}>
          {/*@ts-expect-error always present*/}
          <div className={styles.textCardHeader}>{data[`card${_idx}_header`]}</div>
          {/*@ts-expect-error always present*/}
          <div className={styles.textCardCopy}>{data[`card${_idx}_text`]}</div>
        </div>
        <div className={styles.flipBack}>
          <div className={styles.textCardCopy}>{moreText}</div>
        </div>
      </div>
    </div>
  )
}

export default function LargeHeroBannerBlockClient(data: Block_Large_Hero_Banner) {
  return (
    <div className={styles.container}>
      <PageGutter>
        <div className={styles.headersAndButtonsContainer}>
          <div className={styles.headersContainer}>
            <h1 className={styles.header}>{data.heading}</h1>
            <div className={styles.subheader}>{data.subheading}</div>
          </div>
          {!!data.cta_buttons?.length && (
            <div className={styles.buttonsContainer}>
              {data.cta_buttons?.map((_, idx) =>
                _?.cta_button_id ? <CTAButton key={idx} {..._.cta_button_id} /> : null,
              )}
            </div>
          )}
        </div>
        <div className={styles.cardsContainer}>
          {new Array(4).fill(null).map((_, idx) => {
            const _idx = idx * 2 + 1
            return (
              <div key={idx} className={styles.cardPair}>
                <TextCard {...data} _idx={_idx} />
                <DirectusImage
                  /*@ts-expect-error always present*/
                  directusFile={data[`card${_idx + 1}_image`]}
                  className={styles.imageCard}
                />
              </div>
            )
          })}
        </div>
      </PageGutter>
    </div>
  )
}
